export default {
  header: 'Elegir menú',
  open_now: 'Abierto ahora',
};
